import TextEdit from './TextEdit';

export default TextEdit;